const actions = {
  ADD_COMPANY_BEGIN: 'ADD_COMPANY_BEGIN',
  ADD_COMPANY_SUCCESS: 'ADD_COMPANY_SUCCESS',
  ADD_COMPANY_ERR: 'ADD_COMPANY_ERR',

  GET_COMPANIES_BEGIN: 'GET_COMPANIES_BEGIN',
  GET_COMPANIES_SUCCESS: 'GET_COMPANIES_SUCCESS',
  GET_COMPANIES_ERR: 'GET_COMPANIES_ERR',

  DELETE_COMPANY_BEGIN: 'DELETE_COMPANY_BEGIN',
  DELETE_COMPANY_SUCCESS: 'DELETE_COMPANY_SUCCESS',
  DELETE_COMPANY_ERR: 'DELETE_COMPANY_ERR',

  UPDATE_COMPANY_BEGIN: 'UPDATE_COMPANY_BEGIN',
  UPDATE_COMPANY_SUCCESS: 'UPDATE_COMPANY_SUCCESS',
  UPDATE_COMPANY_ERR: 'UPDATE_COMPANY_ERR',

  AddCompanyBegin: () => {
    return {
      type: actions.ADD_COMPANY_BEGIN,
    };
  },

  AddCompanySuccess: (data) => {
    return {
      type: actions.ADD_COMPANY_SUCCESS,
      data,
    };
  },

  AddCompanyErr: (err) => {
    return {
      type: actions.ADD_COMPANY_ERR,
      err,
    };
  },

  getCompaniesBegin: () => {
    return {
      type: actions.GET_COMPANIES_BEGIN,
    };
  },

  getCompaniesSuccess: (data) => {
    return {
      type: actions.GET_COMPANIES_SUCCESS,
      data,
    };
  },

  getCompaniesErr: (err) => {
    return {
      type: actions.GET_COMPANIES_ERR,
      err,
    };
  },

  UpdateCompanyBegin: () => {
    return {
      type: actions.UPDATE_COMPANY_BEGIN,
    };
  },

  UpdateCompanySuccess: (data) => {
    return {
      type: actions.UPDATE_COMPANY_SUCCESS,
      data,
    };
  },

  UpdateCompanyErr: (err) => {
    return {
      type: actions.UPDATE_COMPANY_ERR,
      err,
    };
  },

  DeleteCompanyBegin: () => {
    return {
      type: actions.DELETE_COMPANY_BEGIN,
    };
  },

  DeleteCompanySuccess: (data) => {
    return {
      type: actions.DELETE_COMPANY_SUCCESS,
      data,
    };
  },

  DeleteCompanyErr: (err) => {
    return {
      type: actions.DELETE_COMPANY_ERR,
      err,
    };
  },
};

export default actions;
